import { DateCell } from '../TableCells/DateCell';
import { ValueCell } from '../TableCells/ValueCell';

export const resolvedProblemsTableColumns = [
  {
    Header: 'Name',
    accessor: 'name',
    width: 20,
    Cell: ValueCell,
  },
  {
    Header: 'Entity Type',
    accessor: 'entity',
    width: 15,
  },
  {
    Header: 'Resolved by',
    accessor: 'fixedBy',
    width: 20,
    Cell: ValueCell,
  },
  {
    Header: 'Old QBO ID',
    accessor: 'assumedMappingId',
    width: 25,
    Cell: ValueCell,
  },
  {
    Header: 'New QBO ID',
    accessor: 'quickBooksFixedId',
    width: 25,
    Cell: ValueCell,
  },
  {
    Header: 'Detected Date',
    accessor: 'detectedAt',
    width: 15,
    Cell: DateCell,
  },
  {
    Header: 'Resolved Date',
    accessor: 'fixedAt',
    width: 15,
    Cell: DateCell,
  },
];
